import { RefiVerifyIdQuizQuestion } from './verify-id-quiz-question.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../styles/reset.style.js';
import '../../styles/forms.style.js';
import '../../styles/radio-buttons.style.js';

defineRefiElement('refi-verify-id-quiz-question', RefiVerifyIdQuizQuestion);
